/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRotate2 = createReactComponent("rotate-2", "IconRotate2", [
  ["path", { d: "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5", key: "svg-0" }],
  ["path", { d: "M18.37 7.16l0 .01", key: "svg-1" }],
  ["path", { d: "M13 19.94l0 .01", key: "svg-2" }],
  ["path", { d: "M16.84 18.37l0 .01", key: "svg-3" }],
  ["path", { d: "M19.37 15.1l0 .01", key: "svg-4" }],
  ["path", { d: "M19.94 11l0 .01", key: "svg-5" }]
]);

export { IconRotate2 as default };
//# sourceMappingURL=IconRotate2.js.map
